import React from 'react';
import type { GetServerSideProps } from 'next';

import { ItemType } from '../../src/client/pages/home/components/content-tiles/utils/map-content';
import AcquisitionLandingPageTemplate, {
  getTemplateServerSideProps,
} from '../../components/page-templates/acquisition-landing-page-template';
import type { Offer, Placeholder } from '../../src/client/components/offers/types';

const slug = 'offers-content';

export type OffersLandingPageProps = {
  activeOffers: Offer[];
  pageContent: {
    item: ItemType;
  }[];
  placeholders: Placeholder[];
};

const OffersLandingPage = ({
  activeOffers: serverSideOffers,
  pageContent: serverSidePageContent,
  placeholders: serverSidePlaceholders,
}: OffersLandingPageProps) => (
  <AcquisitionLandingPageTemplate
    activeOffers={serverSideOffers}
    pageContent={serverSidePageContent}
    placeholders={serverSidePlaceholders}
    slug={slug}
  />
);

export const getServerSideProps: GetServerSideProps = getTemplateServerSideProps({ slug });

export default OffersLandingPage;
